export const INVITATION_EMAIL_SENT = 'invitation-email:sent';
